/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React, {useState} from 'react';
import './PerformancePeriodFilter.scss';

import { connect } from 'react-redux';
import PeriodSelector from 'components/layouts/Bar/Selection/PeriodSelector/PeriodSelector';

import Store from 'state/Store';
import {
  selectedCustomFromDate,
  selectedCustomToDate,
  selectedPeriod,
  toggledCustomDate
} from 'state/performance/PerformancePageActions';
import {
  getFormattedDateRangeForFilterType,
  getInceptionDateForFilterType,
  isCustomDateForFilterType,
} from 'state/performance/PerformancePageSelectors';
import DateRangeInput from 'components/shared/Input/DateRangeInput';
import {beaconDatePickerEnabled} from 'services/FeatureFlags';
import { getPortfolioAsOfDate } from 'state/portfolio/PortfolioSelectors';
import DateRangeInputBeacon from 'components/shared/Input/DateRangeInputBeacon';

const PerformancePeriodFilter = ({
  inceptionDate,
  selectedDateRange,
  isCustomRange,
  maxDate,
  filterType,
}) => {

  const [fromDateBeacon, setFromDateBeacon] = useState(selectedDateRange.fromDate);
  const [toDateBeacon, setToDateBeacon] = useState(selectedDateRange.toDate);
  const selectionChange = (e, selected) => {
    Store.dispatch(selectedPeriod(selected.value, filterType));
  };

  const goCTAClickFunction = () => {
    Store.dispatch(selectedCustomFromDate(fromDateBeacon, filterType));
    Store.dispatch(selectedCustomToDate(toDateBeacon, filterType));
  }

  // Custom Date actions
  const toggleTimePeriod = () => {
    Store.dispatch(toggledCustomDate(!isCustomRange, filterType));
  };

  const onFromDateChange = (date) => {

    if (beaconDatePickerEnabled()) {
      setFromDateBeacon(date);
    } else {
      //flagoff
      Store.dispatch(selectedCustomFromDate(date, filterType));
    }
  };

  const onToDateChange = (date) => {

    if (beaconDatePickerEnabled()) {
      setToDateBeacon(date);
    } else {
      //flagoff
      Store.dispatch(selectedCustomToDate(date, filterType));
    }
  };

  return (
    <div className="performance-period-filter">
      {!isCustomRange ? (
        <PeriodSelector
          filterType={filterType}
          onChange={selectionChange}
          toggleTimePeriod={toggleTimePeriod}
          timePeriodLabel="View Custom Range"
        />
      ) : beaconDatePickerEnabled() ? (
        <DateRangeInputBeacon
          timePeriodLabel="View Time Period"
          toggleTimePeriod={toggleTimePeriod}
          maxDate={maxDate}
          hideLabels={true}
          fromLabel= {'From'}
          toLabel={'To'}
          minDate={inceptionDate}
          customClasses={'beacon-date-picker'}
          fromDate={selectedDateRange.fromDate}
          toDate={selectedDateRange.toDate}
          fromDateBeacon={fromDateBeacon}
          toDateBeacon={toDateBeacon}
          toggleFromDate={onFromDateChange}
          toggleToDate={onToDateChange}
          filterType={filterType}
          isCustomRange={isCustomRange}
          goCTAClickFunction={goCTAClickFunction}
        />
      ) : (
         <DateRangeInput
           timePeriodLabel="View Time Period"
           toggleTimePeriod={toggleTimePeriod}
           maxDate={maxDate}
           minDate={inceptionDate}
           fromDate={selectedDateRange.fromDate}
           toDate={selectedDateRange.toDate}
           toggleFromDate={onFromDateChange}
           toggleToDate={onToDateChange}
         />
      )}
    </div>
  );
};

const mapStateToProps = (state, { filterType }) => {
  return {
    inceptionDate: getInceptionDateForFilterType(state, filterType),
    selectedDateRange: getFormattedDateRangeForFilterType(state, filterType),
    isCustomRange: isCustomDateForFilterType(state, filterType),
    maxDate:  getPortfolioAsOfDate(state),
    filterType
  };
};

export default connect(mapStateToProps)(PerformancePeriodFilter);
